import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReassign = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.45703 12.2227C10.2983 12.2227 12.6005 14.4388 12.6006 17.1748C12.6006 17.6302 12.217 17.9998 11.7441 18H1.45703C0.984043 17.9999 0.600586 17.6303 0.600586 17.1748C0.600696 14.4388 2.90286 12.2227 5.74414 12.2227H7.45703ZM14.166 7.1709C14.3892 6.94312 14.7524 6.94312 14.9756 7.1709L17.833 10.0859C18.0562 10.3137 18.0562 10.6843 17.833 10.9121L17.834 10.9141L14.9775 13.8291C14.7543 14.0569 14.3912 14.0569 14.168 13.8291C13.9449 13.6014 13.9449 13.2317 14.168 13.0039L16.0488 11.083H10.5713C10.2553 11.0829 10 10.8225 10 10.5C10 10.1775 10.2553 9.91709 10.5713 9.91699H16.0508L14.166 7.99609C13.9431 7.76836 13.943 7.39861 14.166 7.1709ZM6.60059 4C8.51293 4.00005 10.0623 5.49152 10.0625 7.33301C10.0625 9.17465 8.51304 10.6669 6.60059 10.667C4.68809 10.667 3.13867 9.17467 3.13867 7.33301C3.13885 5.49149 4.6882 4 6.60059 4Z",
		fill: "#0D2976"
	})
});
export default SvgReassign;
